import { http } from '@/core/api/';

const BASE_API_AT = 'api/atservice';

export const searchAt = async (filter) => {
  const { status, data: response } = await http.get(`${BASE_API_AT}/search`, {
    params: filter,
  });
  if (status !== 200) return [];
  return response;
};

export default {
  completeAtService(peiAtServiceId) {
    return http.post(`api/atservice/complete/${peiAtServiceId}`, {});
  },
  async notCompleteAtService(peiAtServiceId) {
    return http.post(`api/atservice/notcomplete/${peiAtServiceId}`, {});
  },
  async createAtService(peiId) {
    const data = { peiId: peiId };
    const result = await http.post(`api/atservice/saveGeneral`, data);

    if (result && result.status === 200) {
      return result.data;
    }

    return 0;
  },
  async getGeneralInformation(peiAtServiceId, peiId) {
    return await http.get(
      `${BASE_API_AT}/getgeeneralinfo/${peiAtServiceId}/${peiId}`
    );
  },
};
